/* Sham FAQ - JS Logic */

class ShamFaq extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.items = this.querySelectorAll('.sham-faq__item');
        this.bindEvents();
    }

    bindEvents() {
        this.items.forEach(item => {
            const question = item.querySelector('.sham-faq__question');
            if (question) {
                question.addEventListener('click', () => {
                    this.toggleItem(item);
                });
            }
        });
    }

    toggleItem(targetItem) {
        // Toggle item state
        const isActive = targetItem.classList.contains('is-active');

        if (isActive) {
            this.closeItem(targetItem);
        } else {
            this.openItem(targetItem);
        }
    }

    openItem(item) {
        item.classList.add('is-active');

        // Activate Shared Reveal Wrapper
        const wrapper = item.querySelector('.sham-reveal-wrapper');
        if (wrapper) wrapper.classList.add('is-expanded');

        const button = item.querySelector('.sham-faq__question');
        if (button) button.setAttribute('aria-expanded', 'true');
    }

    closeItem(item) {
        item.classList.remove('is-active');

        // Deactivate Shared Reveal Wrapper
        const wrapper = item.querySelector('.sham-reveal-wrapper');
        if (wrapper) wrapper.classList.remove('is-expanded');

        const button = item.querySelector('.sham-faq__question');
        if (button) button.setAttribute('aria-expanded', 'false');
    }
}

customElements.define('sham-faq', ShamFaq);
